import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "./BookCancelModal.css";

const BookCancelModal = ({ onClose, onConfirm, setShowCancelModal }) => {
  const { t } = useTranslation();
  const [isExiting, setIsExiting] = useState(false);

  const handleYesClick = () => {
    setShowCancelModal(true);
    onConfirm();
  };

  const handleNoClick = () => {
    setIsExiting(true);
    setTimeout(() => {
      onClose();
      setShowCancelModal(false);
      setIsExiting(false); // Reset the state for re-opening
    }, 50); // Match the animation duration
  };

  return (
    <div className="book-cancel-modal-container">
        <div
          className={`bg-white w-full max-w-lg rounded-t-3xl p-6 flex flex-col justify-between ${
            isExiting ? "animate-slide-down" : "animate-slide-up"
          }`}
        >
          {/* Modal Header */}
          <div className="text-center">
            <h2 className="text-lg font-bold text-black">
              {t("Book cancellation")}
            </h2>
            <p className="text-sm text-gray-600 mt-2">
              {t("Are you sure you want to cancel your booking")}? <br />
              {t("This action cannot be undone")}.
            </p>
          </div>

          {/* Modal Buttons */}
          <div className="flex justify-between mt-6">
            <button
              className="w-full mx-1 py-2 border border-black text-black rounded-xl"
              onClick={handleNoClick}
            >
              {t("NO")}
            </button>
            <button
              className="w-full mx-1 py-2 bg-black text-white rounded-xl"
              onClick={handleYesClick}
            >
              {t("YES")}
            </button>
          </div>
        </div>
      {/* </div> */}
    </div>
  );
};

export default BookCancelModal;
